import { requestOtpAction, verifyOtpAction } from '~/api/functions/auth/login.action'
import type { AuthResponse, OtpVerifyPayload, RequestOtpPayload } from '~/api/typings'

export function useAuth() {
  const auth = useState<{
    token: string
    userData?: any
  } | null>('auth', () => null)

  const initAuth = () => {
    if (import.meta.client && !auth.value) {
      const token = localStorage.getItem('sdkjfdg2g8')

      if (token) {
        auth.value = {
          token,
        }
      }
    }
  }

  const setAuth = (token: string, userData?: any) => {
    auth.value = {
      token,
      userData,
    }

    if (import.meta.client) {
      localStorage.setItem('sdkjfdg2g8', token)
    }
  }

  const clearAuth = () => {
    auth.value = null

    if (import.meta.client) {
      localStorage.removeItem('sdkjfdg2g8')
    }
  }

  const requestOtp = useMutation<AuthResponse, RequestOtpPayload>((payload) =>
    requestOtpAction(payload).then((r) => {
      if (r.data) return r.data as unknown as AuthResponse
      throw new Error('Failed to request OTP')
    })
  )

  const verifyOtp = useMutation<AuthResponse, OtpVerifyPayload>((payload) =>
    verifyOtpAction(payload).then((r) => {
      if (r.data) return r.data as unknown as AuthResponse
      throw new Error('Failed to verify OTP')
    })
  )

  return {
    auth: readonly(auth),
    setAuth,
    clearAuth,
    initAuth,
    requestOtp,
    verifyOtp,
  }
}
